<div class="hidden md:flex justify-content-center mb-4">
  <img src="../../../../assets/images/logo-sm.svg" alt="PayMe logo" />
</div>
